// 個人設定
$(() => {
    if (document.getElementById('client-regist-invitation') != null) {
        // js-add-invitation-list によって追加された要素に対してもイベントを設定する
        $(document).on('click', '.js-invitation-clear', function(e) {
            $(this).parent().parent().find('.js-invitation-email').val('');
            $(this).parent().parent().find('.js-invitation-role').val(1);
        });

        // クリックするたびに入力欄を追加
        $('.js-add-invitation-list').on('click', function(e) {
            // 入力欄の数が5未満なら追加。上限数を動的に変える必要があればマジックナンバーを修正
            if ($('#client-regist-invitation .list-group-item-action').length < 5) {
                var html = $('#client-regist-invitation .list-group-item-action').prop('outerHTML');
                $('#client-regist-invitation .list-group').append(html);
            }
            // 入力欄の数が5なら .js-add-invitation-list を見えないようにする
            if ($('#client-regist-invitation .list-group-item-action').length == 5) {
                $('.js-add-invitation-list').parent().hide();
            }
            // 1つ目の入力欄以外では削除リンクを表示
            if ($('#client-regist-invitation .list-group-item-action').length > 1) {
                $('#client-regist-invitation .list-group-item-action').each(function(index, element) {
                    if (index != 0) {
                        $(this).find('.js-delete-invitation-list').parent().show();
                    }
                });
            }
        });
        // 削除リンクをクリックすると入力欄を削除
        $(document).on('click', '.js-delete-invitation-list', function(e) {
            $(this).parent().parent().parent().remove();
            // 入力欄の数が5未満なら入力欄を見えるようにする
            if ($('#client-regist-invitation .list-group-item-action').length < 5) {
                $('.js-add-invitation-list').parent().show();
            }
        });
    }

    if (document.getElementById('workflow') != null) {
        $('.js-add').on('click', function(e) {
            var html = $('.js-users option:selected').html();
            var id = $('.js-users option:selected').val();
            if (id) {
                $('.js-users option:selected').remove();
                $('.js-workflow').append($('<option class="list-group-item wf-item">').html(html).val(id));
            }
        });
        $('.js-remove').on('click', function(e) {
            var html = $('.js-workflow option:selected').html();
            var id = $('.js-workflow option:selected').val();
            if (id) {
                $('.js-workflow option:selected').remove();
                $('.js-users').append($('<option class="list-group-item wf-item">').html(html).val(id));
            }
        });
        $('.js-submit').on('click', function(e) {
            var id = [];
            $('.js-workflow option').each(function() {
                id.push($(this).val());
            });
            $('input[name="workflow"]').val(id.join(','));
        });

        $('.js-workflow-change').on('click', function(e) {
            if ($('#notification_users_all_application').prop("checked") ||
                $('#invoice_workflow_all_application').prop("checked") ||
                $('#report_workflow_all_application').prop("checked")
            ) {
                $('#notification_users_modal').modal('show');
            } else {
                $(this).prop('disabled', true);
                $('#workflow').submit();
            }
        });

        $('.submit_notification_users').on('click', function(e) {
            $('#workflow').submit();
        });
    }

    // slack連携
    if (document.getElementById('client-slack-integration') != null) {
        $('#common_modal').on('show.bs.modal', function (event) {
            $('.modal-exec').click(function(event) {
                let anchor = $('.js-revoke-slack-integration');
                anchor.addClass('disabled');
                $('#common_modal').modal('hide');
                window.location = anchor.attr('href');
            });
        })
    }
});
